import { serviceConfig } from '../../config';
import { axiosInstance } from '../../services/shared';
import { AxiosResponse } from 'axios';
import {
  GetUpdateApplications,
  GetUpdateVersions,
  ManagementQuery,
  PostApplication,
  PostVersion,
  UpdateApplications,
} from './types';
import { PutManagementBody } from './types';

async function getVersions(query: ManagementQuery) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/updates`;
  let responseContent;

  try {
    const response: AxiosResponse<GetUpdateVersions> = await axiosInstance.get(url, { params: query });
    responseContent = response.data.content;
    responseContent.map(e => (e.applicationName = e.applicationName.replaceAll(' NV', '')));
    responseContent.sort((a, b) => a.applicationName.localeCompare(b.applicationName));
    return response.data;
  } catch (error) {
    console.error('Error fetching Management updates:', error);
    throw error;
  }
}

export { getVersions };

async function updateVersion(reqBody: PutManagementBody) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/updates`;

  try {
    const response: AxiosResponse<PutManagementBody> = await axiosInstance.put(url, reqBody);
    return response.data;
  } catch (error) {
    console.error('Error changing Management update:', error);
    throw error;
  }
}

export { updateVersion };

async function saveVersion(reqBody: PostVersion) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/updates`;

  try {
    const response: AxiosResponse<PostVersion> = await axiosInstance.post(url, reqBody);
    return response.data;
  } catch (error) {
    console.error('Error changing Management update:', error);
    throw error;
  }
}

export { saveVersion };

async function deleteVersion(id: string) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/updates`;

  try {
    const response: AxiosResponse<PutManagementBody> = await axiosInstance.delete(`${url}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error changing Management update:', error);
    throw error;
  }
}

export { deleteVersion };

async function getApplication() {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/applications`;
  let responseContent;

  try {
    const response: AxiosResponse<GetUpdateApplications> = await axiosInstance.get(url);
    responseContent = response.data.content;
    responseContent.sort((a, b) => a.name.localeCompare(b.name));
    return response.data;
  } catch (error) {
    console.error('Error fetching Management Applications:', error);
    throw error;
  }
}

export { getApplication };

async function saveApplication(reqBody: PostApplication) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.management}/applications`;

  try {
    const response: AxiosResponse<UpdateApplications> = await axiosInstance.post(url, reqBody);
    return response.data;
  } catch (error) {
    console.error('Error creating update Management Application:', error);
    throw error;
  }
}

export { saveApplication };
